var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.101,
    height: 83,
    viewBox: "0 0 75.101 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my_profile",
    transform: "translate(-2.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8428",
    "data-name": "Path 8428",
    d: "M47.952,14.5H32.143C15.779,14.518,2.517,28.469,2.5,45.684a2.03,2.03,0,0,0,1.976,2.079H75.619A2.03,2.03,0,0,0,77.6,45.684C77.578,28.469,64.316,14.518,47.952,14.5ZM6.527,43.6c1.047-14.071,12.2-24.932,25.615-24.947h15.81C61.368,18.673,72.52,29.534,73.567,43.6Z",
    transform: "translate(0 36.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8429",
    "data-name": "Path 8429",
    d: "M27.416,47.237c11.552,0,20.916-10.239,20.916-22.868S38.968,1.5,27.416,1.5,6.5,11.739,6.5,24.368,15.87,47.223,27.416,47.237Zm0-41.579c9.451,0,17.113,8.377,17.113,18.711s-7.662,18.71-17.113,18.71S10.3,34.7,10.3,24.368s7.666-18.7,17.113-18.711Z",
    transform: "translate(12.632)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/my_profile.934288a405e3413770da106ad68edc73.svg";
export { ForwardRef as ReactComponent };